// import axios from "axios";
// import { disableKeyboardShortcuts } from "./util/disableShortcuts"; // 👈 Add this

// const axiosInstance = axios.create({
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("AccessToken");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;

//   },
//   (error) => Promise.reject(error)
// );

// disableKeyboardShortcuts(); // 👈 Call here once
// // 🔁 Intercept responses to capture refreshed token or handle 401
// axiosInstance.interceptors.response.use(
//   (response) => {
//     const newToken = response.headers["x-new-token"];
//     if (newToken) {
//       localStorage.setItem("AccessToken", newToken);
//     }
//     return response;
//   },

//   (error) => {
//   if (
//     error.response &&
//     (
//       (error.response.status === 401 &&
//         (error.response.data?.message?.toLowerCase() === "invalid or expired token") ||
//       error.response.data?.error?.toLowerCase() === "unauthorized" )
      
//     )
//   ) {
//       localStorage.removeItem("AccessToken");
//       localStorage.removeItem("user_id");
//       localStorage.removeItem("privilege");
//       localStorage.removeItem("user_name");

//       // Optional: Clear cookies or session flags
//       document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//       sessionStorage.setItem("logout", "true");

//       window.location.href = "/auth/login";
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;


import axios from "axios";
import { disableKeyboardShortcuts } from "./util/disableShortcuts"; 

// 👇 yaha define karo public pages jo bina login ke open honge
const PUBLIC_PATHS = ["/agreement"];

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// helper: check if request/url is public
const isPublicRequest = (configOrUrl) => {
  try {
    const url = typeof configOrUrl === "string" ? configOrUrl : (configOrUrl?.url || "");
    const pathname = typeof window !== "undefined" ? window.location.pathname : "";
    return (
      PUBLIC_PATHS.some((p) => url.includes(p)) ||
      PUBLIC_PATHS.some((p) => pathname.startsWith(p))
    );
  } catch (e) {
    return false;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    // 👇 agar public request hai to token attach na karo
    if (isPublicRequest(config)) {
      return config;
    }

    const token = localStorage.getItem("AccessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

disableKeyboardShortcuts(); 

axiosInstance.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-new-token"];
    if (newToken) {
      localStorage.setItem("AccessToken", newToken);
    }
    return response;
  },
  (error) => {
    const cameFromPublic = isPublicRequest(error?.config) || isPublicRequest();

    // 👇 agar ye public request hai to login page pe redirect mat karo
    if (!cameFromPublic && error.response &&
      ((error.response.status === 401 &&
        (error.response.data?.message?.toLowerCase() === "invalid or expired token" ||
         error.response.data?.error?.toLowerCase() === "unauthorized"))
      )
    ) {
      localStorage.removeItem("AccessToken");
      localStorage.removeItem("user_id");
      localStorage.removeItem("privilege");
      localStorage.removeItem("user_name");

      document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      sessionStorage.setItem("logout", "true");

      window.location.href = "/auth/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
